const enTranslation = {
  common: {
    close: 'Close',
    flagCaution: 'Sensitive topic. Double-check this answer.',
    flagInfo: 'Good to know.',
    welcome: 'Welcome',
    login: 'Login',
    logout: 'Logout',
    send: 'Send',
    stop: 'Stop',
    retry: 'Retry',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    typeToFilter: 'Type to filter…',
    save: 'Save',
    language: 'Language',
    newChat: 'New conversation',
    startingNewChat: 'Starting new conversation...',
    searchMessage: 'Thinking and analyzing relevant information...',
    searchMessageTiming: 'Searching through work instructions and knowledge items...',
    tryAgain: 'Try Again',
    back: 'Back',
    enabled: 'Enabled',
    disabled: 'Disabled',
    goBack: 'Go Back',
    attachDocument: 'Attach document',
    aiDisclaimer: 'Responses are generated by AI. Always verify important information through official sources.',
    copyAnswer: 'Copy answer',
    copyMessage: 'Copy message',
    copied: 'Copied!',
    copyToClipboard: 'Copy to clipboard',
    expand: 'Expand',
    minimize: 'Minimize',
    showMore: 'Show more',
    noInternalKnowledge: 'No internal knowledge found',
    noAdditionalResponse: 'No additional response',
    // Dual answer UX
    swapMessage: 'We found a company-specific answer. The general answer is still available below.',
    toggleShowGeneral: 'Show general answer (ChatGPT)',
    toggleHideGeneral: 'Hide general answer',
    progressExternal: 'Searching with ChatGPT…',
    progressInternal: 'Searching company knowledge…',
    internalError: 'Company knowledge unavailable right now.',
    promoteSecondary: 'Use as main answer',
    compareAnswers: 'Compare answers side-by-side',
    switchBack: 'Switch back',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Internal guidelines',
  },
  knowledge_source: {
    general_info: 'Answer based on AI model',
    internal_guidelines: 'Internal guidelines',
    internet_results: 'Internet search results',
    searching_internal: 'Searching company data…',
    searching_internet: 'Searching the internet…',
    badge_ai: 'AI',
    badge_internal: 'Company data',
    badge_internal_searching: 'Searching company data',
    badge_internet: 'Internet',
    badge_internet_searching: 'Searching internet',
  },
  errors: {
    assistantResponseContentViolation:
      "The assistant's response violates our content policy. Please try again or rephrase your question.",
    userInputContentViolation:
      'Your request contains content that violates our content policy. Please rephrase your question.',
    llmProviderUserInputBlocked:
      "Your message was blocked by the AI provider's content filter. Please rephrase your question.",
    llmProviderBotResponseBlocked:
      "The AI response was blocked by the provider's content filter. Please try again or rephrase your question.",
    llmProviderApiError: 'We are experiencing issues with our AI service. Please try again later.',
    serverError: 'An unexpected server error occurred. Please try again or contact support if the problem persists.',
    agentNotFound: 'The assistant you are looking for does not exist or is no longer available.',
    conversationNotFound: 'The conversation you are looking for does not exist or is no longer available.',
    noAccessScopes:
      'You do not currently have access to any knowledge sources. To request access, please create a support ticket or contact your IT administrator.',
    noAccessScopesWithEmail:
      'You do not currently have access to any knowledge sources. To request access, please create a support ticket or contact IT support at {{email}}.',
    startViolatedPoliciesList: 'The following policies were violated',
    questionTooLong: {
      title: 'Your question is too long',
      description: 'The maximum length is 30,000 characters.',
    },
    excelNotSupportedYet: {
      title: 'Excel and CSV support coming soon!',
      description:
        "We're working on Excel and CSV file support and it will be available soon. Please use PDF or Word files for now.",
    },
  },
  auth: {
    welcomeTester: 'Welcome colleague',
    welcomeMessage: 'Welcome to {{assistantName}}!',
    loginWithMicrosoft: 'Login with Microsoft',
    loginInstructions: 'Log in with your Microsoft account to begin.',
    welcomeCompany: 'Welcome to {{companyName}}!',
    loginWithPassword: 'Login with username and password',
    hidePasswordForm: 'Hide',
    login: 'Login',
  },
  chat: {
    placeholder: 'Ask your question here',
    thinking: 'Thinking...',
    anonymousUser: 'Anonymous',
    howToAskGoodQuestion: 'How to ask a good question?',
    askQuestion: 'Ask your question',
    exampleQuestions: 'Example questions',
    tryAsking: 'Try asking:',
    assistant: '{{assistantName}}, your digital assistant',
    welcomeMessage:
      'Hi {{name}}! I am {{assistantName}}, your digital assistant. I can help you with questions about the work instructions and knowledge items. What would you like to know?',
    loading: 'Loading conversation...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    serverError: 'An unexpected server error occurred. Please try again or contact support if the problem persists.',
    disclaimerText: 'AI-generated answers. No rights can be derived from these answers.',
    dropFilesHere: 'Drop files here to add to chat',
    addMenu: 'Add',
    addFiles: 'Add file',
    searchHrKnowledge: 'Search HR knowledge',
    hrKnowledgeOff: 'HR knowledge off',
    filteredTo: 'Filtered to',
    filters: 'Filters',
    filtersInfo: 'Limits the chat to specific filters.',
    unsupportedFileType: 'File type not supported',
    uploadingFile: 'Uploading file…',
    uploadLimit: 'Maximum file size: 10 MB',
    fileTooLarge: 'File size must be less than 10 MB',
    fileTypeNotAllowed: 'Only PDF, Word, Excel, PowerPoint (PPTX), CSV, and TXT files are allowed',
    documentUploaded: 'Document uploaded successfully',
    documentUploadFailed: 'Failed to upload document',
    documentRemoved: 'Document removed',
    documentRemoveFailed: 'Failed to remove document',
  },
  internetSearch: {
    badgeLabel: 'Internet search on',
    badgeTooltip: 'This assistant can use the internet to search',
    inlineWarning:
      'Note: Do not share company-sensitive or personal data. Inputs for internet search may be used by Microsoft for training.',
    dismiss: 'Dismiss',
    modalTitle: 'Be careful with sensitive data',
    modalBody:
      'This assistant uses internet searches. Do not share company-sensitive or personal information. Inputs may be processed by Microsoft and used to train models. Only share what is necessary and follow company policy.',
    gotIt: 'Got it',
  },
  agentChat: {
    placeholder: 'Type your question for agent...',
    welcomeMessage: 'Hi, I am your AI agent. How can I help you today?',
    privilegedWelcomeMessage: 'Hi {{userName}}! {{description}}',
    startPrompt: 'Ask a question to get started',
  },
  profile: {
    settings: 'Settings',
    selectLanguage: 'Select your language',
    appearance: 'Appearance',
    darkMode: 'Dark Mode',
    languageChanged: 'Language changed',
    noEmailAvailable: 'No email available',
    general: 'General',
    models: 'Models',
    noModelsAvailable: 'No models available',
    modelSettings: 'Model settings',
    savingSettings: 'Saving...',
    settingsUpdateFailed: 'Failed to save model settings. Please try again.',
  },
  sidebar: {
    conversations: 'History',
    assistants: 'Assistants',
    userGuide: 'User guide',
    chatHistory: 'Conversational history',
    today: 'Today',
    thisWeek: 'This week',
    lastWeek: 'Last week',
    earlier: 'Earlier',
    conversation: 'Conversation',
    noAssistantsAvailable: 'No assistants available',
    noContent: 'No content',
    noPreviousConversations: 'No previous history found',
    searchConversations: 'Search history...',
    noSearchResults: 'No history matching your search',
    favorites: 'Favorites',
    noFavorites: 'No favorites',
    addFavoritesHint: 'Go to the library to add assistants to your favorites.',
    loadingPrivilegedAgents: 'Loading assistants...',
    rename: 'Rename',
    conversationActions: 'Conversation actions',
    renameConversationError: 'Failed to rename conversation',
    delete: 'Delete',
    deleteConversation: 'Delete conversation',
    deleteConversationConfirm: 'Are you sure you want to delete the chat conversation: {{title}}?',
    deleteConversationError: 'Failed to delete conversation',
  },
  feedback: {
    likeAnswer: 'Like answer',
    dislikeAnswer: 'Dislike answer',
    feedbackSent: 'Your feedback has been sent! ✅',
    provideFeedback: 'Provide feedback on the question',
    enterFeedback: 'Enter your feedback here',
    send: 'Send',
    assistantFallback: 'AI assistant',
    downvoteDisclaimer:
      'When you press send, your last two messages will be shared anonymously for analysis to help improve {{assistant}}.',
    reasons: {
      incorrect: 'Answer is incorrect',
      sourceIncorrect: 'Source is incorrect',
      other: 'Other...',
    },
  },
  // Generic information pop-out — client-agnostic.
  // Texts are feature-flag driven and use {{companyName}} for the company name.
  informationModal: {
    title: 'About the {{companyName}} assistant',
    intro:
      'Welcome to the {{companyName}} assistant. Below you will find what the assistant can help you with and how to get the most out of it.',
    capabilitiesTitle: 'What can the assistant help you with?',
    activeVanillaChat:
      'The assistant can answer questions like the ones you would ask ChatGPT.',
    activeVanillaInactiveWebSearch:
      'The assistant has broad general knowledge, but does not know about current events such as the latest news.',
    activeInternalSearch:
      'The assistant can answer questions based on a specific selection of internal information sources.',
    activeInternetSearch:
      'The assistant can search the internet to answer questions about current events.',
    activeInternetSearchPrivacyWarning:
      'Note: questions and answers from internet searches, like regular internet use, are not fully private. Do not share confidential company information when using web search.',
    activeDocumentUpload:
      'You can upload documents and discuss them with the assistant, for example to summarize them or extract action points.',
    activeAgents:
      'You can select specific <1>assistants</1> to talk to. Each assistant has its own instructions and is therefore better at specific tasks.',
    activeModelSelection:
      'In the message input field you choose which AI model answers your question. On the <1>model settings page</1> you can adjust each model\'s settings to control how it responds.',
    usageTipsTitle: 'How to get the most out of the assistant',
    askClearQuestions:
      'Ask a clear question in full sentences. Single keywords often produce mediocre answers; a full sentence gives the assistant the context it needs to help you well.',
    conversationHistory:
      'Within one conversation the assistant remembers what you said earlier, so you can ask follow-up questions. It does not understand what you mean if you refer to information from other conversations.',
    startNewConversation:
      'Start a new conversation (button at the top left) when switching to a different topic, so answers stay sharp.',
    bewareAssistantsNotAgents:
      'Note: this is an AI assistant, not an AI agent. It helps you with individual tasks when you ask, for example summarizing an email, but does not autonomously take follow-up actions like sending emails.',
    feedback:
      'Use the thumbs under an answer to give feedback. That helps make the assistant smarter.',
    dataVisibilityNoticeTitle: 'Data visibility notice',
    bewareDoNotSharePersonalInformation: 'Note: do not share personal information.',
    supportTitle: 'Need help?',
  },
  library: {
    title: 'Assistants Library',
    subtitle:
      'Discover and create custom versions of assistants that combine instructions, extra knowledge, and any combination of skills.',
    searchPlaceholder: 'Search assistants...',
    createAgent: 'Create Assistant',
    createFirstAgent: 'Create your first assistant',
    noAgents: 'No assistants available',
    noSearchResults: 'No assistants matching your search',
    noDescription: 'No description available',
    active: 'Active',
    library: 'Library',
    of: 'of',
    assistants: 'assistants',
    clearFilters: 'Clear filters',
    filtersCleared: 'Filters cleared',
    all: 'All',
    favorites: 'Favorites',
    normal: 'Normal',
    privileged: 'Privileged',
    noTags: 'No tags',
    agentSelected: 'Assistant selected',
    isNowActive: 'is now active',
    select: 'Select',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    moreTags: 'more tags',
    editAgent: 'Edit assistant',
  },
  createAgent: {
    title: 'New Assistant',
    subtitle: 'Create a new AI assistant to help your team',
    saving: 'Saving...',
    saveAgent: 'Save Assistant',
    basicInfo: 'Basic Information',
    classification: 'Classification',
    tagsAndCustomization: 'Tags & Customization',
    icon: 'Icon',
    name: 'Name',
    namePlaceholder: 'Give the assistant a name',
    description: 'Description',
    descriptionPlaceholder: 'Describe what the assistant can do',
    department: 'Department',
    selectDepartment: 'Select a department',
    jobCategory: 'Job Category',
    selectJobCategory: 'Select a job category',
    tags: 'Tags',
    optional: 'optional',
    addNewTag: 'Add a new tag',
    add: 'Add',
    existingTags: 'Existing tags',
    promptTemplate: 'Prompt Template',
    promptTemplatePlaceholder:
      'Define how the assistant should respond... (for example: You are a helpdesk assistant who responds kindly and professionally to questions about...)',
    fillAllRequiredFields: 'Please fill in all required fields',
    agentCreated: 'Assistant created',
    createdSuccessfully: 'was created successfully',
    creationError: 'Creation error',
    creationErrorDescription: 'An error occurred while creating the assistant',
    unsavedChanges: 'Unsaved changes',
    unsavedChangesMessage: 'You have made changes that have not been saved yet. Are you sure you want to go back?',
    manageJobCategories: 'Manage job categories for this department',
    instructions: 'Instructions',
    instructionsDescription: 'Define how your assistant should behave and respond to users',
    instructionsLabel: 'Instructions',
    instructionsPlaceholder: 'You are a helpful assistant that...',
    instructionsHelperText: "Be specific about the assistant's role, tone, and how it should help users",
    instructionsMinLength: 'Instructions must be at least 20 characters',
    tools: 'Tools',
    searchTool: 'Search tool',
    toolsFileSearch: 'File search',
    toolsInternetSearch: 'Internet search',
    tracing: 'Tracing',
    tracingHelp: 'Control if and how the inner behaviour of this agent are logged for diagnostic purposes. Overrides tool-based settings',
    tracingAlways: 'On',
    tracingNever: 'Off',
    tracingToolBased: 'Tool-based',
    featureRequest: 'Feature request',
    deleteAssistant: 'Delete Assistant',
    tagsHelp: 'Tags help organize and categorize your assistant',
    exampleQuestions: 'Example Questions',
    exampleQuestionsHelp: 'Add example questions that users can click to start a conversation',
  },
  editAgent: {
    title: 'Edit Assistant',
    subtitle: "Modify your AI assistant's settings and behavior",
    updateAgent: 'Update Assistant',
    deleteAgent: 'Delete Assistant',
    updating: 'Updating...',
    deleting: 'Deleting...',
    agentUpdated: 'Assistant Updated',
    updatedSuccessfully: 'has been updated successfully',
    updateError: 'Update Error',
    updateErrorDescription: 'There was an error updating the assistant. Please try again.',
    agentDeleted: 'Assistant Deleted',
    deletedSuccessfully: 'has been deleted successfully',
    deleteError: 'Delete Error',
    deleteErrorDescription: 'There was an error deleting the assistant. Please try again.',
    deleteConfirmTitle: 'Delete Assistant',
    deleteConfirmMessage: 'Are you sure you want to delete this assistant? This action cannot be undone.',
    confirmDelete: 'Yes, Delete',
    loadingAgent: 'Loading assistant details...',
    failedToLoad: 'Failed to load assistant details',
  },
  jobCategory: {
    addNew: 'Add Category',
    name: 'Name',
    nameRequired: 'Category name is required',
    enterName: 'Enter category name...',
    create: 'Create',
    edit: 'Edit',
    update: 'Update',
    delete: 'Delete',
    created: 'Category Created',
    createdSuccessfully: 'was created successfully',
    updated: 'Category Updated',
    updatedSuccessfully: 'was updated successfully',
    deleted: 'Category Deleted',
    deletedSuccessfully: 'was deleted successfully',
    creationError: 'Creation Error',
    creationErrorDescription: 'An error occurred while creating the category',
    updateError: 'Update Error',
    updateErrorDescription: 'An error occurred while updating the category',
    deletionError: 'Deletion Error',
    deletionErrorDescription: 'An error occurred while deleting the category',
    deleteError: 'Delete Error',
    deleteErrorDescription: 'An error occurred while deleting the category',
    deleteConfirmTitle: 'Delete Category',
    deleteConfirmMessage: 'Are you sure you want to delete "{{name}}"?',
    deleteWarning: 'This action cannot be undone and may affect existing agents.',
    warning: 'Warning',
    agentsWillLoseCategory: 'agents will lose their category assignment',
  },
  languageNames: {
    en: 'English',
    nl: 'Dutch',
    de: 'German',
    fr: 'French',
    it: 'Italian',
    pl: 'Polish',
    hu: 'Hungarian',
    id: 'Indonesian',
  },
  knowledgeSourceSelector: {
    title: 'Knowledge sources',
    tooltip: 'Choose which knowledge sources to search',
    all: 'All',
  },
  countries: {
    nl: 'Netherlands',
    us: 'Americas',
    hu: 'Hungary',
    id: 'Indonesia',
  },
  iconSelector: {
    chooseIcon: 'Choose an icon',
  },
  models: {
    introHeading: 'Model settings',
    introBody: "On this page you set how each model behaves. Which model is used for a conversation isn't chosen here, you pick that in the chat itself, next to the input field where you type your question.",
    noConfigurableParameters: 'No settings for this model',
  },
}

const clientDefaults = {
  fallbackAgentDescription: 'AI assistant for company knowledge from AHV International.',
}

export default { ...enTranslation, ...clientDefaults }
